module.exports = __webpack_public_path__ + "static/img/wx_duokai.7ac4665b.png";